import { useMutation } from '@tanstack/react-query';
import { formBuilderApi } from '@/features/quote-and-apply-builder';
import type { SaveFormParams } from '@/features/quote-and-apply-builder';

export function useSaveForm() {
  return useMutation({
    mutationFn: (params: SaveFormParams) => formBuilderApi.saveForm(params),
  });
}
